import ProductAttributesApiV2 from 'api/v2/admins/product-attributes-api-v2'
import InputField from 'components/molecules/input-field'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { STATUS_OPTION } from 'domains/product-attribute/constants'

const propTypes = {
  code       : PropTypes.string,
  name       : PropTypes.string,
  label      : PropTypes.string,
  required   : PropTypes.bool,
  isCuration : PropTypes.bool
}

const defaultProps = {
  isCuration: false
}

/**
 * Render dynamic input select field. It made from `InputSelectField`
 * @param {string} code - Product Attribute code
 * @param {string} name - Field name in the formik bag
 * @param {string} label - Product Attribute label
 * @param {bool} required - Product Attribute curation field required
 * @param {bool} isCuration - Set true if it's for curation form
 */
const ProductAttributeInputSelectField = ({
  code,
  name,
  label,
  required,
  isCuration,
  ...props
}) => {
  const [ options, setOptions ] = useState([])


  useEffect(() => {
    if (options.length > 0) return

    const optionsFormCache = sessionStorage.getItem(code)
    if (optionsFormCache) {
      const jsonOptions = JSON.parse(optionsFormCache)

      setOptions(jsonOptions)
    }
    else {
      const optionEndpoint = isCuration
        ? ProductAttributesApiV2.getCurationOptions({ attributeCode: code })
        : ProductAttributesApiV2.getOptions({ attributeCode: code, additionalFilters: { status: STATUS_OPTION.ENABLED } })

      optionEndpoint.then((response) => {
        const options = response.data.options

        setOptions(options)
        sessionStorage.setItem(code, JSON.stringify(options))
      })
        .catch(() => {
          alert(`Failed: Get Attribute ${code}`)
        })
    }

  }, [ code, isCuration, options.length ])


  return (
    <InputField
      key={ `${code}-attribute-input-field` }
      type='select'
      name={ name }
      label={ label }
      required={ required }
      // turn of auto suggest from the input field
      autoComplete='off'
      autoCorrect='off'
      spellCheck='off'
      { ...props }
    >
      <option key='' value=''>Choose one</option>
      {
        options.map((option) => (
          <option
            key={ `{code}-options-${option.label}` }
            value={ option.id }
          >
            { option.label }
          </option>
        ))
      }
    </InputField>
  )
}

ProductAttributeInputSelectField.propTypes    = propTypes
ProductAttributeInputSelectField.defaultProps = defaultProps

export default ProductAttributeInputSelectField
